import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllConstantDropdown } from 'Api/constantDropdown';

export const fetchConstantDropdownAction = createAsyncThunk(
	'constantDropdown',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getAllConstantDropdown(params);
			return response.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);
